<template>
  <div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <div>
                    <h5>
                    الملاحظات عند دخول الطلاب
                    <br>
                </h5>
                <p>تظهر هنا الملاحظات الموجودة على الطلاب وقام الطالب بالحضور للمدرسة بعد اضافة الملاحظة.</p>
                </div>
            </div>
            <div class="card-body">
                <div class="col-12 g">
                    <sort-select id="scan-notes-sort" v-model="sort" />
                </div>
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-bordered table-sm">
                        <thead>
                            <th>
                                الطالب
                            </th>
                            <th>
                                الملاحظة
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="note in sortedNotes" :key="note._id">
                                <td>
                                    {{ student(note.number).name }}
                                </td>
                                <td>
                                    {{ note.content }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { sort_rows } from '@/libs/list-sort'

export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            students: {},
            sort: "",
            notes: []
        }
    },
    created(){
        if(!(checkPer("students|notes") || checkPer("students|scan|ends"))){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        $.post(api + '/user/students/list', {
            jwt: this.user.jwt,
            page: 1,
            perpage: 10000
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                r.response.forEach(function(a){
                    g.students[a.number] = a;
                })
                g.getNotes()
            }
        }).fail(function(){
            g.loading = false;
        })
    },
    computed: {
        // the list in the chosen order of its students (name / class from the students list)
        sortedNotes(){
            var g = this;
            return sort_rows(this.notes.map(function(x){
                var s = g.student(x.number);
                return { name: s.name, classname: s.classname, classroom: s.classroom, row: x };
            }), this.sort).map(function(x){ return x.row; });
        },
    },
    methods: {
        getNotes(){
            var g = this;
            $.post(api + '/user/students/notes/with-report', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.notes = r.response;
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        student(number){
            if(this.students[number]){
                return this.students[number];
            }else{
                return {};
            }
        }
    }
}
</script>

<style>

</style>